import { gql } from '@apollo/client'

import { MENU_CURATION_TASK_DETAILS_FRAGMENT } from '../fragments'

const MENU_CURATION_TASK_QUERY = gql`
  query menuCurationTask($id: ID!) {
    menuCurationTask(id: $id) {
      ...MenuCurationTaskDetailsFragment
    }
  }
  ${MENU_CURATION_TASK_DETAILS_FRAGMENT}
`

export default MENU_CURATION_TASK_QUERY
